const prodottoVuotoPerDatiUlteriori = {
    /* codiceVS: "",
    codicePS: "",
    brand: "",          
    codiceProduttore: {
        codProduttoreIntero: "",
        codProduttoreModello: "",
        codProduttoreColore: "",
        codProduttoreCollezione: ""
    }, */
    /* shortName: {
        it: "",
        en: "",
        fr: "",
        de: "",
        es: ""
    }, */
    /* descrizioniSuPS: {
        titolo: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        },
        descBreve: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        },
        descLunga: {
            it: "",
            en: "",
            fr: "",
            de: "",
            es: ""
        }
    },   */  
    /* tradotto: {
        en: false,
        fr: false,
        de: false,
        es: false
    },
    strutturato: false,
    tradottoStrutturato: false,
    esportato: false,
    dataUltimaEsportazione: false */
    categorieWebAssociate: []
};

export default prodottoVuotoPerDatiUlteriori;